import api, { ApiResponse } from "../api";

export interface EmployeeNotificationPreference {
  source: string;
  emailEnabled: boolean;
  inappEnabled: boolean;
}

class EmployeeNotificationPreferencesService {
  private static instance: EmployeeNotificationPreferencesService;
  private constructor() {}
  static getInstance(): EmployeeNotificationPreferencesService {
    if (!EmployeeNotificationPreferencesService.instance) {
      EmployeeNotificationPreferencesService.instance = new EmployeeNotificationPreferencesService();
    }
    return EmployeeNotificationPreferencesService.instance;
  }

  public getPreferences = async (
    email: string
  ): Promise<ApiResponse<EmployeeNotificationPreference[]>> => {
    return await api.get(`/emp-notifications/preferences/email/${encodeURIComponent(email)}`);
  };

  public updatePreference = async (
    email: string,
    preference: EmployeeNotificationPreference
  ): Promise<ApiResponse<any>> => {
    return await api.put(`/emp-notifications/preferences/email/${encodeURIComponent(email)}`, preference);
  };
}

export default EmployeeNotificationPreferencesService;

